import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ComponentsModule } from './components/components.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { HttpInterceptor } from './interceptors/http.interceptor';
import { ModalsModule } from './modals/modals.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // Import BrowserAnimationsModule
import { ApmErrorHandler, ApmModule } from '@elastic/apm-rum-angular'

import { ConfigService } from './services/config.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule, IonicModule.forRoot({
      mode: 'md',
      innerHTMLTemplatesEnabled: true
    }), AppRoutingModule,
    HttpClientModule, ComponentsModule, RecaptchaV3Module, ModalsModule, ApmModule
    , BrowserAnimationsModule // Add BrowserAnimationsModule to imports
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: HttpInterceptor,
    multi: true,
  }, { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  // {
  //   provide: RECAPTCHA_V3_SITE_KEY,
  //   useValue: environment.recaptcha.siteKey,
  // },
  {
    provide: RECAPTCHA_V3_SITE_KEY,
    useFactory: (config: ConfigService) => config.getSiteKey(),
    deps: [ConfigService]
  },
  {
    provide: ErrorHandler,
    useClass: ApmErrorHandler
  }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
